module.exports = __webpack_public_path__ + "static/media/how-to-earn-money-through-instagram.5ccd3258.png";